module.exports = __webpack_public_path__ + "img/lg_ring_r_l_1_null@2x.38147522.png";